const language = {
	spanish: {
		yellow_text: "BENEFICIOS",
		bold_text:
			"Proteja sus activos móviles y comerciales con los múltiples beneficios  que Foresight GPS le ofrece como:",
	},
	english: {
		yellow_text: "BENEFITS",
		bold_text:
			"Protect your mobile and commercial assets with the multiple benefits that Foresight GPS offers, such as:",
	},
};

export default language;